<template>
  <v-row>
  <v-col cols="12" sm="3">
    <h4>Contacts Details</h4>
  </v-col>
  <v-col cols="12" sm="4">
     <v-select
        v-model="contactadd.contact_id"
        :items="allcontacts"
        item-text="name"
        item-value="id"
        :rules="[v => !!v || 'Item is required']"
        label="Select Contact"
        required
      ></v-select>
  </v-col>
  <v-col cols="12" sm="5">
     <v-btn color="success" class="mr-2" @click="addcontact()">Submit</v-btn>

     <AddContact :projectid="projectid"/>
  </v-col>

  <v-col cols="12" sm="12">
  <v-simple-table class="w-100">
    <template v-slot:default>
          <thead>
              <tr>
              <th>Contact Name</th>
              <th>Mobile No.</th>
              <th>Email</th>
              <th>Action</th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="contact in contacts" :key="contact.id">
                  <td>{{ contact.name }}</td>
                  <td>{{ contact.mobile }}</td>
                  <td>{{ contact.email }}</td>
                  <td><EditContact :contactid="contact.id" :projectid="projectid"/></td>
              </tr>
          </tbody>
    </template>
  </v-simple-table>
  </v-col>
  </v-row>
</template>

<style scoped>
  .w-100{
    width:100%;
  }
</style>

<script>
import EditContact from './EditContact.vue';
import AddContact from './AddContact.vue';
import { mapGetters,mapActions } from 'vuex';
  export default {
    components : {
      EditContact,
      AddContact
    },
    props : {
        contacts : Array,
        projectid : Number
    },
    data: function() {
      return {
        contactadd : {
          contact_id: '',
          project_client_contact_id: this.projectid,
          project_client_contact_type: "App\\Models\\project"
        }
      }
    },
    methods: {
        ...mapActions(['addprojectcontact']),
        addcontact() {
          if(this.contactadd.contact_id)
          {
              this.addprojectcontact(this.contactadd);
              this.contactadd.contact_id = '';
          }
        }
    },
    computed: {
      ...mapGetters(["allcontacts"]),
    }
  }
</script>